export default __webpack_public_path__ + "static/media/0x02649c1ff4296038de4b9ba8f491b42b940a8252.a7b49223.webp";